import { defaultTo } from 'ramda';
import { IWriteOffInfoSchema } from '../../../repositories/billing-tariffs/entities/PublishTerms/WriteOffInfoSchema';
import { ITotalAmount } from '../../../types/reducers/checkoutInfo';

export function mapTotalAmount(writeOffInfo?: IWriteOffInfoSchema | null): ITotalAmount {
  const { moneyAmount, pointsAmount } = writeOffInfo?.total || {};

  return {
    price: defaultTo(0, moneyAmount),
    auctionPoints: defaultTo(0, pointsAmount),
  };
}
